<template>
  <div class="content">
      <panel-card-group :panel-data="panelChartData" v-show="cardGroupShow"/>
      <panel-order-group :panel-data="panelOrderData" v-show="orderGroupShow"/>
      <el-row style="background:#fff;padding:16px 16px 0;margin-bottom:32px;">
      <el-tabs v-model="activeTab" @tab-click="panelGroupClick">
        <el-tab-pane label="卡数统计" name="card" >
            <card-line-chart v-if="activeTab ==='card'" :chart-data="lineCardData" />
            <card-line-day-chart v-if="activeTab ==='card'" :chart-data="lineCardDayData" />
        </el-tab-pane>
        <el-tab-pane label="订单统计" name="order" >
            <order-line-chart v-if="activeTab ==='order'" :chart-data="lineOrderData" />
            <order-line-day-chart v-if="activeTab ==='order'" :chart-data="lineOrderDayData" />
        </el-tab-pane>
        <el-tab-pane label="首充复充" name="charge">
            <user-recharge-day-chart v-if="activeTab ==='charge'" :chart-data="userRechargeDayData" />
        </el-tab-pane>
        <el-tab-pane label="卡源统计" name="cardSource">
            <card-source-chart v-if="activeTab ==='cardSource'" :chart-data="cardSourceData" />
        </el-tab-pane>
        <el-tab-pane label="卡归属代理商统计" name="cardAgent">
           <card-agent-chart v-if="activeTab ==='cardAgent'" :chart-data="cardAgentData" />
           <sale-agent-chart v-if="activeTab ==='cardAgent'" :chart-data="cardAgentData" />
        </el-tab-pane>
        <el-tab-pane label="运营商统计" name="operator">
          <card-operator-chart v-if="activeTab ==='operator'"  :chart-data="cardOperatorData" />
        </el-tab-pane>
        <el-tab-pane label="30天流量消耗" name="flow">
          <card-flow-chart v-if="activeTab ==='flow'" :chart-data="lineCardData" />
          <card-day-flow-chart v-if="activeTab ==='flow'" :chart-data="lineCardDayData" />
        </el-tab-pane>
      </el-tabs>
    </el-row>
  </div>
</template>
<script>

import PanelCardGroup from '../dashboard/PanelCardGroup.vue'
import PanelOrderGroup from '../dashboard/PanelOrderGroup.vue'
import CardLineChart from '../dashboard/CardLineChart.vue'
import CardLineDayChart from '../dashboard/CardLineDayChart.vue'
import OrderLineChart from '../dashboard/OrderLineChart.vue'
import OrderLineDayChart from '../dashboard/OrderLineDayChart.vue'
import CardSourceChart from '../dashboard/CardSourceChart.vue'
import CardAgentChart from '../dashboard/CardAgentChart.vue'
import SaleAgentChart from '../dashboard/SaleAgentChart.vue'
import CardOperatorChart from '../dashboard/CardOperatorChart.vue'
import CardFlowChart from '../dashboard/CardFlowChart.vue'
import CardDayFlowChart from '../dashboard/CardDayFlowChart.vue'
import UserRechargeDayChart from '../dashboard/UserRechargeDayChart.vue'
import { panelCardData,panelLineCardData,panelOrderData,panelOrderLineData,cardSourceData,cardAgentData ,cardOperatorData,userRechargeData} from "@/api/api.js"; //当月卡数据
export default {
  name: "dataAnalysis",
  components: {
    PanelCardGroup,
    PanelOrderGroup,
    CardLineChart,
    CardLineDayChart,
    OrderLineChart,
    OrderLineDayChart,
    CardSourceChart,
    CardAgentChart,
    SaleAgentChart,
    CardOperatorChart,
    CardFlowChart,
    CardDayFlowChart,
    UserRechargeDayChart
  },
  data() {
    return {
      // 查询条件
      userId: undefined,
      panelChartData:{},
      panelOrderData:{},
      lineCardData:{},
      lineCardDayData:{},
      lineOrderData:{
        timeList:[],
        refundMoneyList:[],
        wxMoneyList:[],
        webMoneyList:[],
        alipayMoneyList:[],
        balanceMoneyList:[],
        newMoneyList:[]
      },
      lineOrderDayData:{},
      cardSourceData:{},
      cardAgentData:{
        data:[]
      },
      cardOperatorData:{
        data:[]
      },
      userRechargeDayData:{},
      cardGroupShow:true,
      orderGroupShow:false,
      activeTab: 'card'
    };
  },
  computed: {},
  
  methods: {
    panelGroupClick(tab, event){
      let name = tab.name;
      if(name == 'card'){
        this.cardGroupShow = true;
        this.orderGroupShow = false;
      }
      if(name == 'order'){
        this.panelOrderDataMethod();
        this.panelOrderLineDataMethod("1");
        this.panelOrderLineDayDataMethod("2");
        this.cardGroupShow = false;
        this.orderGroupShow = true;
      }
      if(name== 'cardSource'){
          this.cardSourceDataMethod();
      }
      if(name== 'charge'){
          this.userRechargeDayDataMethod('2');
      }
      if(name== 'cardAgent'){
          this.cardAgentDataMethod();
      }
      if(name== 'operator'){
          this.cardOperatorDataMethod();
      }
    },
    initPanelCardData(){
        panelCardData({userId:this.userId}).then(res=>{
            if(res.data.code == 200){
                this.panelChartData = res.data.data;
            }
        })
    },
    panelOrderDataMethod(){
        panelOrderData({userId:this.userId}).then(res=>{
            if(res.data.code == 200){
                this.panelOrderData = res.data.data;
            }
        })
    },
    panelOrderLineDataMethod(type){
      panelOrderLineData({userId:this.userId,type:type}).then(res=>{
            if(res.data.code == 200){
                this.lineOrderData = res.data.data;
            }
        })
    },
    panelOrderLineDayDataMethod(type){
      panelOrderLineData({userId:this.userId,type:type}).then(res=>{
            if(res.data.code == 200){
                this.lineOrderDayData = res.data.data;
            }
        })
    },
    cardSourceDataMethod(){
        cardSourceData({userId:this.userId}).then(res=>{
          if(res.data.code == 200){
              this.cardSourceData = res.data;
          }
        })
    },
    cardAgentDataMethod(){
        cardAgentData({userId:this.userId}).then(res=>{
          if(res.data.code == 200){
              this.cardAgentData = res.data;
          }
        })
    },
    cardOperatorDataMethod(){
        cardOperatorData({userId:this.userId}).then(res=>{
          if(res.data.code == 200){
              this.cardOperatorData = res.data;
          }
        })
    },
    userRechargeDayDataMethod(type){
        userRechargeData({userId:this.userId,type:type}).then(res=>{
          if(res.data.code == 200){
              this.userRechargeDayData = res.data.data;
          }
        })
    },
    initLineCardData(type){
        panelLineCardData({userId:this.userId,type:type}).then(res=>{
          if(res.data.code == 200){
              this.lineCardData = res.data.data;
          }
        })
    },
    initLineCardDayData(type){
        panelLineCardData({userId:this.userId,type:type}).then(res=>{
          if(res.data.code == 200){
              this.lineCardDayData = res.data.data;
          }
        })
    }
  },
  watch: {
	  '$route' (to, from) {
      if(to.fullPath.indexOf('dataAnalysis')!=-1){
        if(this.userId!=this.$route.query.userId){
          this.userId = this.$route.query.userId
          this.activeTab='card';
          this.initPanelCardData();
          this.initLineCardData("1");
          this.initLineCardDayData("2");
        }
      }
      
    }
	},
  created() {

  },
  mounted() {
    this.userId = this.$route.params && this.$route.params.userId;
    this.initPanelCardData();
    this.initLineCardData("1");
    this.initLineCardDayData("2");
  },
};
</script>
<style lang="less" scoped>
 .content{
    background-color: #f0f2f5;
 }
</style>



